import SupportPractitionerPlansWorkspacePage from 'src/supportPortal/views/practitioners/therapists/SupportPractitionerPlansWorkspacePage'

export default function TherapistsEvents() {
  return <SupportPractitionerPlansWorkspacePage defaultTab="overview" />
}
